"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HybridFlowIds = void 0;
var HybridFlowIds;
(function (HybridFlowIds) {
    HybridFlowIds["ACCOUNT_DETAILS"] = "accountDetails";
    HybridFlowIds["ACCOUNT_MOVEMENTS"] = "accountMovements";
    HybridFlowIds["AGGREGATOR"] = "aggregator";
    HybridFlowIds["CARD_ASSOCIATE_ACCOUNTS"] = "cardAssociateAccounts";
    HybridFlowIds["CARD_CONTROL"] = "cardControl";
    HybridFlowIds["CARD_INFORMATION"] = "cardInformation";
    HybridFlowIds["CARD_MODIFY"] = "cardModify";
    HybridFlowIds["CARD_MODIFY_ATM_LIMITS"] = "cardModifyATMLimits";
    HybridFlowIds["CARD_MOVEMENTS"] = "cardMovements";
    HybridFlowIds["CREATE_NEW_SIGNATURE_KEY_VU"] = "createNewSignatureKeyVu";
    HybridFlowIds["DOCUMENTATION"] = "documentation";
    HybridFlowIds["FISERV_WIDGET_FEEDBACK_LANDING_FLOW_ID"] = "fiservWidgetFeedback";
    HybridFlowIds["GLOBAL_POSITION"] = "globalPosition";
    HybridFlowIds["INSURANCES_LANDING"] = "insurancesLanding";
    HybridFlowIds["INTERNAL_TRANSFER"] = "internalTransfer";
    HybridFlowIds["LANDING_ACCOUNTS"] = "landingAccounts";
    HybridFlowIds["LANDING_CARDS"] = "landingCards";
    HybridFlowIds["LANDING_DEPOSITS"] = "landingDeposits";
    HybridFlowIds["LANDING_LOANS"] = "landingLoans";
    HybridFlowIds["LANDING_TRANSFERS"] = "landingTransfers";
    HybridFlowIds["LOGOUT"] = "logout";
    HybridFlowIds["MODIFY_ALIAS"] = "modifyAlias";
    HybridFlowIds["MORTGAGE_PANEL"] = "mortgagePanel";
    HybridFlowIds["ONBOARDING_FINISHED"] = "onboardingFinished";
    HybridFlowIds["ONBOARDING_LANDING"] = "onboardingLanding";
    HybridFlowIds["PAYMENTS_LANDING"] = "paymentsLanding";
    HybridFlowIds["PERSONAL_DATA"] = "personalData";
    HybridFlowIds["PERSONAL_DATA_PHONE_MODIFICATION"] = "personalData-phoneModification";
    HybridFlowIds["PROMOTIONS_DISCOUNTS"] = "promotionsDiscounts";
    HybridFlowIds["ROBO_LANDING"] = "robo";
    HybridFlowIds["SECURITY_LANDINGS"] = "securityLandings";
    HybridFlowIds["UPDATE_EMAIL"] = "updateEmail";
    HybridFlowIds["UPDATE_PHONE"] = "updatePhone";
    HybridFlowIds["WEALTH_LANDING"] = "wealth";
})(HybridFlowIds || (exports.HybridFlowIds = HybridFlowIds = {}));
//# sourceMappingURL=idFlows.js.map